// @ts-nocheck
import * as React from 'react';
// TrustRail — right column: counsellor stats, path, accreditations, foundations.

import Avatar from '../components/common/Avatar';
import { TODAY_STATS, COUNSELLOR, PATH } from '../data/constants';
import { ACCREDITATIONS } from '../data/accreditations';
import { LEADERS } from '../data/leaders';
import './TrustRail.css';

export default function TrustRail() {
  const today = TODAY_STATS;
  return (
    <section className="A-col A-col--trust">
      {/* Counsellor performance */}
      <div className="A-trust-card">
        <div className="A-trust-card__head">
          <Avatar p={{ avatarBg: "linear-gradient(135deg,#dbeafe,#1769ff)", initials: COUNSELLOR.initials }} size={28} />
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: "var(--fg)" }}>{COUNSELLOR.name}</div>
            <div style={{ fontSize: 10.5, color: "var(--fg-tertiary)" }}>{COUNSELLOR.role}</div>
          </div>
        </div>
        <div className="A-stats">
          <div className="A-stat">
            <div className="A-stat__n">{today.enquiries}</div>
            <div className="A-stat__l">New today</div>
          </div>
          <div className="A-stat">
            <div className="A-stat__n">{today.demosTriggered}</div>
            <div className="A-stat__l">Demos sent</div>
          </div>
          <div className="A-stat">
            <div className="A-stat__n A-stat__n--green">{today.converted}</div>
            <div className="A-stat__l">Converted</div>
          </div>
        </div>
        <div className="A-progress">
          <div className="A-progress__row">
            <span>Weekly target</span>
            <strong>{today.weekConverted} / {today.weekTarget}</strong>
          </div>
          <div className="A-progress__bar">
            <div className="A-progress__fill" style={{ width: `${(today.weekConverted / today.weekTarget) * 100}%` }} />
          </div>
        </div>
      </div>

      {/* Path to Competitive Success */}
      <div className="A-trust-card">
        <div className="eyebrow eyebrow--mute" style={{ marginBottom: 10 }}>Path to Competitive Success</div>
        <div className="A-path">
          {PATH.map((s, i) => (
            <div key={s.id} className="A-path__step">
              <div className="A-path__num">{s.step}</div>
              <div className="A-path__label">{s.label}</div>
              {i < PATH.length - 1 && <div className="A-path__line" />}
            </div>
          ))}
        </div>
        <p style={{ fontSize: 11, color: "var(--fg-tertiary)", marginTop: 10, lineHeight: 1.5 }}>
          Roadmap generator auto-builds a study plan for every admitted student.
        </p>
      </div>

      {/* Accreditations */}
      <div className="A-trust-card">
        <div className="eyebrow eyebrow--mute" style={{ marginBottom: 10 }}>Accreditations</div>
        <div className="A-accreds">
          {ACCREDITATIONS.slice(0, 8).map((a) => (
            <div key={a.id} className="A-accred">
              <img src={a.path} alt={a.label} />
              <span>{a.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Thought Leaders */}
      <div className="A-trust-card">
        <div className="eyebrow eyebrow--mute" style={{ marginBottom: 10 }}>Foundations</div>
        <div className="A-leaders">
          {LEADERS.slice(0, 8).map((L) => (
            <div key={L.id} className="A-leader" title={`${L.name} — ${L.work}`}>
              <div className="A-leader__av" style={{ background: L.bg }}>{L.i}</div>
              <div className="A-leader__info">
                <div className="A-leader__name">{L.name}</div>
                <div className="A-leader__work">{L.work}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
